import { render, staticRenderFns } from "./About.vue?vue&type=template&id=7c3bba0d&scoped=true"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"
import style0 from "./About.vue?vue&type=style&index=0&id=7c3bba0d&prod&lang=scss&scoped=true"
import style1 from "./About.vue?vue&type=style&index=1&id=7c3bba0d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c3bba0d",
  null
  
)

export default component.exports